var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.relationships
        ? _c("v-skeleton-loader", {
            staticClass: "mb-6",
            attrs: {
              type: "list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line",
              boilerplate: "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-expansion-panels",
        {
          attrs: { accordian: "", flat: "" },
          on: {
            change: function ($event) {
              return _vm.$emit("change")
            },
          },
          model: {
            value: _vm.panel,
            callback: function ($$v) {
              _vm.panel = $$v
            },
            expression: "panel",
          },
        },
        _vm._l(/*user.family*/ _vm.relationships || [], function (item, index) {
          return _c(
            "v-expansion-panel",
            { key: item.id, class: ["mb-2 mt-0", `panel-${index}`] },
            [
              _vm.user.id !== item.id
                ? _c(
                    "v-expansion-panel-header",
                    {
                      class: ["soli-round mb-2 pa-0"],
                      attrs: {
                        "expand-icon": "keyboard_arrow_down",
                        focusable: "",
                      },
                    },
                    [
                      _c(
                        "v-row",
                        { class: ["align-center"] },
                        [
                          _c(
                            "v-col",
                            { staticClass: "col-3 flex justify-center" },
                            [
                              _c(
                                "v-avatar",
                                { attrs: { size: "55" } },
                                [
                                  _c("v-img", {
                                    attrs: { src: item.profile_photo_url },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { staticClass: "pl-0" },
                            [
                              _c("v-list", { staticClass: "mx-2" }, [
                                _c(
                                  "div",
                                  { staticClass: "caption soli-grey" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          //user.family
                                          _vm.relationships
                                            ? item.pivot.user_id !== _vm.user.id
                                              ? item.pivot.relation
                                              : item.pivot.inverse
                                            : null
                                          /*: item.email && !item.loginable
                  ? "Additional Email"
                  : "Child Account"*/
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "soli-grey",
                                      _vm.$vuetify.breakpoint.xsOnly
                                        ? "body-2"
                                        : "body-1",
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.name) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "caption soli-grey flex items-center",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.email) +
                                        "\n                                "
                                    ),
                                    item.email
                                      ? _c("Clipboard", {
                                          attrs: {
                                            text: item.email,
                                            label: "Copy Email",
                                            "x-small": "",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "v-row",
                    { staticClass: "justify-around align-center py-5" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", small: "", color: "dark" },
                          on: {
                            click: function ($event) {
                              _vm.selectedRelationship = item
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("edit")]),
                          _vm._v(" "),
                          _c("small", { staticClass: "mt-1 panel-text" }, [
                            _vm._v("Edit"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            small: "",
                            color: "dark",
                            disabled:
                              _vm.paidByUser(item) ||
                              !_vm.can("Manage user relationships") ||
                              (!_vm.user.email &&
                                _vm.relationships.filter((e) => e.email)
                                  .length <= 1),
                          },
                          on: {
                            click: function ($event) {
                              _vm.confirmRemoveRelationship = item
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("delete_outline")]),
                          _vm._v(" "),
                          _c("small", { staticClass: "mt-1 panel-text" }, [
                            _vm._v("Remove"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Link",
                        {
                          attrs: {
                            //user.family
                            href:
                              //  ? `/students/${user.family_id}/#account`
                              //  :
                              `/profile/${item.id}/account`,
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            { attrs: { icon: "", small: "", color: "dark" } },
                            [
                              _c("v-icon", [_vm._v("account_circle")]),
                              _vm._v(" "),
                              _c(
                                "small",
                                {
                                  staticClass: "mt-1 panel-text",
                                  staticStyle: { "white-space": "normal" },
                                },
                                [_vm._v("Profile")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.confirmRemoveRelationship
        ? _c("SoliChoice", {
            attrs: {
              title: _vm.paysForUser ? "Error" : "Remove Relationship?",
              subtitle: _vm.paysForUser
                ? `This relationship is unable to be removed. ${_vm.confirmRemoveRelationship.first_name} has an active pass or membership that is paid for by this account.`
                : `This can't be undone`,
              button1: _vm.paysForUser ? "Nevermind" : "Delete",
              button2: _vm.paysForUser ? null : "Nevermind",
            },
            on: {
              option1: function ($event) {
                _vm.paysForUser
                  ? null
                  : _vm.removeRelationship(_vm.confirmRemoveRelationship)
              },
              reset: function ($event) {
                _vm.confirmRemoveRelationship = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedRelationship
        ? _c("ManageRelationships", {
            attrs: {
              relationships: _vm.relationships || null,
              relationship: _vm.selectedRelationship,
              user: _vm.user,
            },
            on: {
              success: function ($event) {
                ;[
                  _vm.$emit("success"),
                  _vm.closeModal(() => (_vm.selectedRelationship = null)),
                ]
              },
              reset: function ($event) {
                _vm.selectedRelationship = null
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }